/**
 * @file
 * Contains Login component.
 *
 * Login contains next attributes:
 *  # title {string} - Rewrite default title.
 *  # companyLogo {node} - Set up custom logo.
 *  # onSendCode {function} - handle first form submit.
 *  # onUpdatePassword {function} - handle second form submit.
 *  # styles {object} - Rewrite default styles. Contain of three keys - logoStyle, titleStyle, dialogStyle.
 *  # error {object} - Error handling. Contain of two keys - {user, password}.
 */

import React, { useState } from "react";
import { TextField, Button } from "@material-ui/core";
import "./forgotPassword.css";
import FeUtils from "@fe-sales/common-utils";
import DefaultLogo from "./../assets/img/logo512.png";
import PropTypes from "prop-types";

const ForgotPasswordComponent = ({
  title,
  companyLogo,
  styles,
  error,
  onSendCode,
  onUpdatePassword,
}) => {
  /**
   * Show Code Form state.
   */
  const [showCodeForm, setShowCodeForm] = useState(true);

  /**
   * User state.
   */
  const [user, setUser] = useState("");

  /**
   * Password state.
   */
  const [password, setPassword] = useState("");

  /**
   * RePassword state.
   */
  const [repassword, setRePassword] = useState("");

  /**
   * User error state.
   */
  const [userError, setUserError] = useState(true);

  /**
   * Password error state.
   */
  const [passwordError, setPasswordError] = useState(true);

  /**
   * RePassword error state.
   */
  const [rePasswordError, setRePasswordError] = useState(true);

  const sendCodeHandler = (e) => {
    e.preventDefault();
    if (!userError) {
      onSendCode({
        user,
      });
    }
    setShowCodeForm(false);
  };

  const updateEmailHandler = (e) => {
    if (FeUtils.validateEmail(e.target.value)) {
      setUserError(false);
      setUser(e.target.value);
    } else {
      setUserError(true);
    }
  };

  const updatePassword = (e) => {
    if (e?.target?.value?.length) {
      setPassword(e.target.value);
      setPasswordError(false);
    } else {
      setPasswordError(true);
    }
  };

  const updateRePassword = (e) => {
    if (e?.target?.value?.length) {
      setRePassword(e.target.value);
      setRePasswordError(false);
    } else {
      setRePasswordError(true);
    }
  };

  /*------- Seconf Form -----*/

  /**
   * Code state.
   */
  const [code, setCode] = useState("");

  const updateCode = (e) => {
    if (e?.target?.value?.length) {
      setCode(e.target.value);
    }
  };

  const updatePasswordHandler = (e) => {
    e.preventDefault();
    if (!userError || !passwordError) {
      onUpdatePassword({
        user,
        code,
        password,
        repassword,
      });
    }
  };

  return (
    <div>
      <img
        src={companyLogo ? companyLogo : DefaultLogo}
        alt=""
        className="cui_forgot-password_logo"
        style={styles?.logoStyle}
      />
      <div className="cui_forgot-password_title" style={styles?.titleStyle}>
        {title ? title : "Welcome"}
      </div>
      <div className="cui_forgot-password_dialog" style={styles?.dialogStyle}>
        {showCodeForm && (
          <form className="cui_forgot-password_form" onSubmit={sendCodeHandler}>
            <TextField
              required
              id="user"
              label="Email"
              // value={email}
              onChange={updateEmailHandler}
              error={!!error?.user}
              helperText={!!error?.user ? error?.user : ""}
            />

            <Button
              variant="contained"
              type="submit"
              style={styles?.buttonStyle}
              disabled={userError}
            >
              Send Code
            </Button>
          </form>
        )}

        {!showCodeForm && (
          <form
            className="cui_forgot-password_form"
            onSubmit={updatePasswordHandler}
          >
            <TextField
              required
              id="user"
              label="Email"
              value={user}
              onChange={updateEmailHandler}
              error={!!error?.user}
              helperText={!!error?.user ? error?.user : ""}
            />
            <TextField
              required
              id="code"
              label="Code"
              // value={email}
              onChange={updateCode}
              error={!!error?.user}
              helperText={!!error?.code ? error?.code : ""}
            />
            <TextField
              required
              id="password"
              label="Password"
              type="password"
              // value={password}
              onChange={updatePassword}
              error={!!error?.password}
              helperText={!!error?.password ? error?.password : ""}
            />
            <TextField
              required
              id="repassword"
              label="Repeat Password"
              type="password"
              // value={password}
              onChange={updateRePassword}
              error={!!error?.rePassword}
              helperText={!!error?.rePassword ? error?.rePassword : ""}
            />
            <Button
              variant="contained"
              type="submit"
              style={styles?.buttonStyle}
              disabled={userError || passwordError}
            >
              Update Password
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};
ForgotPasswordComponent.propTypes = {
  title: PropTypes.string,
  companyLogo: PropTypes.node,
  styles: PropTypes.object,
  error: PropTypes.object,
  onSendCode: PropTypes.func,
  onUpdatePassword: PropTypes.func,
};

export default ForgotPasswordComponent;
